import { render, staticRenderFns } from "./GroupNameTags.vue?vue&type=template&id=7fba67b3&"
import script from "./GroupNameTags.vue?vue&type=script&lang=js&"
export * from "./GroupNameTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports